import { useTheme } from "@mui/material";
// ==============================|| LOGO ICON SVG ||============================== //
const baseHeight = 38;
const baseWidth = 38;
export default function LogoIcon({ width, height }) {
  const theme = useTheme();

  const finalHeigth = height ?? baseHeight;
  const finalWidth = width ?? (finalHeigth * baseHeight) / baseWidth;

  return (
    <svg 
      width={finalHeigth} 
      height={finalWidth} 
      viewBox="0 0 38 38" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.9282 0.0175781H11.2169C11.2169 6.19041 12.7734 10.0878 13.1774 11.1334H0V15.8447H15.6668C16.6827 17.3479 17.8412 18.5301 17.8412 18.5301C17.8412 18.5301 16.6767 19.7124 15.6668 21.2155H0V25.9268H13.1715C12.7675 26.9725 11.2109 30.8758 11.2109 37.0546H15.9222C15.9222 28.2558 19.3027 23.687 21.4178 21.5066C22.4753 22.2077 24.4953 23.3662 26.8836 24.1683C23.206 26.6992 21.3168 31.4699 21.3168 37.0546H26.0281C26.0281 30.454 28.4937 25.9268 37.0429 25.9268L37.037 21.2155C23.6576 21.2155 15.9282 13.2841 15.9282 0.0175781Z" 
        fill={theme.palette.rgd.primary}
      />
      <path d="M37.0494 15.8627V11.1336C28.5001 11.1336 26.0346 6.60645 26.0346 0.00585938L21.3232 0.0236828C21.3232 10.4504 26.997 15.8627 37.0494 15.8627Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}
